import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * The consent banner shown above the document before signing may begin.
 *
 * Presentation only: it owns the checkbox state and nothing else. The host decides whether to
 * show it, what to do on acceptance, and when it goes away.
 *
 * Two things this component deliberately does NOT do:
 *
 *  - It does not block the page. The real gate is that the host has not fetched the signature
 *    fields yet, so there is nothing to click. A disabled button is UX; the server-side check is
 *    the enforcement.
 *  - It does not render Decline. Decline lives in the navbar and must stay reachable the whole
 *    time this banner is up — the disclosure itself tells a signer to withdraw by declining, so
 *    a signer who refuses consent has to have somewhere to go.
 */
@Component({
  selector: 'app-disclosure-consent',
  templateUrl: './disclosure-consent.component.html',
  styleUrls: ['./disclosure-consent.component.css'],
  standalone: false
})
export class DisclosureConsentComponent {
  /** The checkbox sentence, from the disclosure row. Data, not an i18n key — it is part of the consent. */
  @Input() consentText = '';

  /** The disclosure's title, used as the link text that opens the modal. */
  @Input() disclosureTitle = '';

  /** Set while the acceptance request is in flight, to stop a double submit. */
  @Input() submitting = false;

  @Output() accepted = new EventEmitter<void>();
  @Output() openRequested = new EventEmitter<void>();

  checked = false;

  get canAccept(): boolean {
    return this.checked && !this.submitting;
  }

  onAccept(): void {
    if (!this.canAccept) return;
    this.accepted.emit();
  }

  onOpen(event: Event): void {
    event.preventDefault();
    this.openRequested.emit();
  }
}
